<template>
  <div class="telBlock">
    <component
      :is="VueTelInput"
      ref="telephoneRef"
      v-model="formData"
      type="tel"
      :disabled="props.data.disabled"
      class="vti browser-default leading-none m-0 w-full text-[12px] sm:text-[14px] 2xl:text-[14px] py-1.5 px-3 leading-[40px] !h-auto min-h-[36px] sm:min-h-[48px] py-2 px-3 rounded-md te xt-surface-800 dark:text-white/80 placeholder:text-surface-400 dark:placeholder:text-surface-500 bg-surface-0 dark:bg-surface-950 border !border-surface-300 dark:border-surface-700 focus:outline-none focus:outline-offset-0 focus:ring-1 focus:ring-primary-500 dark:focus:ring-primary-400 focus:z-10 appearance-none transition-colors duration-200"
      :class="[
        props.data.errorMessage || phoneData?.valid === false ? 'invalid border-red-500 invalid:focus:ring-red-200 invalid:hover:border-red-500' : 'valid border-surface-300',
        props.data.elementClasses,
        props.data.disabled ? '!bg-surface-200' : 'hover:border-surface-400 dark:hover:border-surface-600'
      ]"
      mode="international"
      default-country="us"
      :valid-characters-only="true"
      :dropdown-options="{
        showSearchBox: true,
        showFlags: true,
        searchBoxPlaceholder: $t('country')
      }"
      @on-input="(data, phoneObject) => { 
        phoneData = phoneObject
      }"
      @validate="(data) => {
        phoneValidate = typeof data?.valid === 'undefined' || (props.data.optional && !formData.length)
          ? true
          : data?.valid

        if (phoneValidate) {
          emit('validData', phoneValidate)
        }
      }"
      @blur="(data) => { 
        formData = phoneData?.number
          ? phoneData?.number
          : formData
            ? formData
            : ''

        emit('returnData', formData)
        emit('validData', phoneValidate)
      }"
    />
  </div>
</template>

<script setup>
const phoneValidate = ref(null)
const phoneData = ref(null)
const VueTelInput = ref(null)

/**
 * https://iamstevendao.github.io/vue-tel-input/
 * 
 * And we also download it asynchronously
 */
const telephoneRef = ref(null)

/**
* Init Plugin
*/
onNuxtReady(async () => {
  const module = await import('vue-tel-input')
  VueTelInput.value = markRaw(module.VueTelInput)
})

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

/**
* FormData
*/
const formData = ref(props.data.formData[props.data.name])

watch(() => props.data.formData[props.data.name], (newVal) => {
  formData.value = newVal
  if (phoneData.value?.formatted) {
    formData.value = phoneData.value?.formatted
  }
})

/**
* Emits
*/
const emit = defineEmits(['returnData', 'validData'])
</script>

<style lang="scss" scoped>
.telBlock {
  &:deep(.vti) {
    &:hover {
      border-color: #e5e7eb!important;
    }

    .vti__input {
      @apply px-3 text-[12px] sm:text-[14px] 2xl:text-[14px] text-surface-800;

      &::placeholder {
        @apply text-[12px] sm:text-[14px] 2xl:text-[14px] text-surface-400;
      }

      &::placeholder,
      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        @apply text-[12px] sm:text-[14px] 2xl:text-[14px] text-surface-400;
      }

      &[disabled] {
        @apply bg-surface-200 text-surface-400;

        &::placeholder {
          @apply text-surface-400;
        }

        &::placeholder,
        &:-ms-input-placeholder,
        &::-ms-input-placeholder {
          @apply text-surface-400;
        }
      }
    }

    .vti__dropdown {
      padding: 0 .5rem 0 0;
      &:hover {
        background-color: transparent;
      }

      &.open {
        background-color: transparent;
      }

      &-item {
        padding: .7rem 10px;
        &:hover {
          background-color: #eee;
        }
      }
      &-list {
        left: 0;
        max-width: 100%;
      }
    }
    .vti__flag {
      margin-left: 0;
    }
    .vti__search_box_container {
      padding: .5rem;
      .vti__input {
        height: 36px !important;
        margin: 0;
        border: 1px solid #d5d3d1 !important;
        border-radius: 4px;
      }
    }
  }
}
</style>
